<template>
  <div class="c-quiz-create">
    <div>
      <n-card class="quiz-card">
        <n-loader :loading="$var('load')" />
        <!--        <c-show-icons v-if="show" :show.sync="show" :value.sync="icon" />-->
        <div class="window-top">
          <n-button @click="closeModal">X</n-button>
        </div>
        <div>
          <div>
            <n-items>
              <!--              <n-button v-if="Object.keys(icon).length === 0" @click="show = true">Выбрать иконку</n-button>-->
              <!--              <div v-else class="icon-place" @click="show = true">-->
              <!--                Иконка раздела-->
              <!--                <div class="image-place">-->
              <!--                  <img :src="icon.src" alt="">-->
              <!--                </div>-->
              <!--              </div>-->
              <n-input title="Название раздела" v-bind="$form.input('title')"></n-input>
              <n-select title="Тип" :data="types" v-bind="$form.input('type', 'select')" />
              <n-select title="Доступ" :data="accesses" v-bind="$form.input('access', 'select')" />
              <n-input title="Порядок" v-bind="$form.input('serialNumber')"></n-input>
            </n-items>
          </div>
          <div class="button-save">
            <n-button color="primary" @click="save">Сохранить</n-button>
          </div>
        </div>
      </n-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CQuizCreate',
  props: {
    categoryId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      category: {},
      accesses: [
        { value: 'open', title: 'Открыт', },
        { value: 'close', title: 'Закрыт', },
      ],
      types: [
        { value: 'theory', title: 'Теория', },
        { value: 'practice', title: 'Практика', },
      ],
      quiz: {},
      show: false,
      icon: {},
    }
  },
  created() {
    this.$form.init()
  },
  methods: {
    closeModal() {
      this.$emit('update:show', false)
    },
    save() {
      this.$var('load', true)
      $api.quizzes.create({
        title: this.$form.get('title'),
        type: this.$form.get('type.value'),
        access: this.$form.get('access.value'),
        serialNumber: this.$form.get('serialNumber'),
        categoryId: this.categoryId,
        // image: Object.keys(this.icon).length !== 0 ? this.icon.id : null,
      }).then(() => {
        this.closeModal()
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.c-quiz-create {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, .2);

  .icon-place {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .image-place {
    width: 64px;
    height: 64px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .window-top {
    display: flex;
    align-items: center;
    justify-content: right;
  }

  .quiz-card {
    min-width: 700px;
    min-height: 300px;
    position: relative;
  }
  .button-save {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: right;
  }
}
</style>
